@if (editionPage$ | async; as editionPage) {

    <app-standard-page-layout class="w-full" 
        [title]="editionPage.name"
        [subtitle]="editionPage.seriesName"
        >

        <div class="mb-4">
            <p class="text-lg">{{ formatFromToDate(editionPage.from, editionPage.to) }}</p>
        </div>
        
        <div class="mb-8">
            <h3 class="mb-4">Shows</h3>
                <div class="
                    grid
                    grid-cols-1
                    md:grid-cols-3
                    lg:grid-cols-4
                    gap-4
                    ">
                    @for (programme of editionPage.programmeList; track programme.id) {
                        <a class="block border rounded-lg p-5 cursor-pointer border-slate-500 hover:border-slate-800 transition"
                            [routerLink]="['/programme', programme.id]">
                            <h3 class="mb-1">{{ programme.name }}</h3>
                            <p class="text-base text-gray-600 mb-4">
                                {{ formatFromToDate(programme.from, programme.to) }}
                            </p>
                        </a>
                    }
                </div>            
        </div>

        <div>
            <h3 class="mb-4">Performances</h3>
                <div class="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    lg:grid-cols-3
                    gap-4
                    ">
                    @for (performance of editionPage.performanceList; track performance.id) {
                        <div class="block border rounded-lg p-4 border-slate-500">
                            @for (performanceItem of performance.performanceItemList; track performanceItem.id) {
                                <div class="flex">
                                    <div class="grow">
                                        <h3 class="mb-1">{{ performanceItem.name }}</h3>
                                        @for (performancePerformer of performanceItem.performerList; track performancePerformer.id) {
                                            <div>
                                                <p class="text-lg">{{ performancePerformer.performer?.name }}</p>
                                            </div>
                                        }
                                        <p class="text-base">{{ performance.name }}</p>
                                    </div>
                                    @if(_userService.isLoggedIn$ | async) {
                                        <div>
                                            <app-outline-star-icon 
                                                class="block w-[44px] h-[44px] cursor text-gray-300 hover:text-gray-500 transition">
                                            </app-outline-star-icon>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>            
        </div>

    </app-standard-page-layout>

}
@else {

    <app-standard-page-layout
        class="w-full"
        title="Loading"
        subtitle="">
    </app-standard-page-layout>
}